import { List } from '../List'
import { CommonWork } from '../CommonWork'
import { SpecialityParent } from '@/models/Speciality'

export class DissertationParent extends List {
  constructor(obj) {
    super(Dissertation, obj)
  }
}

export class Dissertation {
  constructor(obj) {
    this.id = (obj && obj?.id) || null
    this.commonWork = new CommonWork(obj?.commonWork || null)
    this.dissertationSpeciality = new SpecialityParent(obj?.dissertationSpeciality || null)
    this.dissertationDegree = obj?.dissertationDegree || null
    this.protectionPlace = obj?.protectionPlace || null
    this.preparationPlace = obj?.preparationPlace || null
    this.protectionDate = obj?.protectionDate || null
    this.issueDate = obj?.issueDate || null
    this.step = obj?.step || null
    this.diplomaNumber = obj?.diplomaNumber || null
    this.diplomaSeries = obj?.diplomaSeries || null
    this.councilDate = obj?.councilDate || null
    this.specialityNum = obj?.specialityNum || null
    this.notFoundPreparationPlace = obj?.notFoundPreparationPlace || Boolean(obj?.preparationPlaceStr) || false
    this.notFoundProtectionPlace = obj?.notFoundProtectionPlace || Boolean(obj?.protectionPlaceStr) || false
    this.preparationPlaceStr = obj?.preparationPlaceStr || null
    this.protectionPlaceStr = obj?.protectionPlaceStr || null
    this.isPHD = obj?.isPHD || false
  }

  getForAPI() {
    return {
      id: this.id,
      commonWork: this.commonWork.getForAPI(),
      dissertationSpeciality: this.dissertationSpeciality.getForAPI(),
      dissertationDegree: this.dissertationDegree,
      protectionPlace: this.protectionPlace,
      preparationPlace: this.preparationPlace,
      protectionDate: this.protectionDate,
      issueDate: this.issueDate,
      step: this.step,
      diplomaNumber: this.diplomaNumber,
      diplomaSeries: this.diplomaSeries,
      councilDate: this.councilDate,
      specialityNum: this.specialityNum,
      notFoundPreparationPlace: this.notFoundPreparationPlace,
      notFoundProtectionPlace: this.notFoundProtectionPlace,
      preparationPlaceStr: this.preparationPlaceStr,
      protectionPlaceStr: this.protectionPlaceStr,
      isPHD: this.isPHD
    }
  }
}
